import React, {Component} from "react";
import {Tabs} from 'antd';
import getSize from "../../../utils/getSize";
import ZzbdblcxTab from "../zzbdblcx/zzbdblcxTab"
import ZzbdxqTab from "../zzbdblcx/zzbdxqTab"
import css from './index.css';

const TabPane = Tabs.TabPane;

/**
 * 自助报到环节办理查询
 * @author sujunming
 * @date 2018-06-27 14:29:32
 * Version: 1.0
 */
export default class ZzbdblcxIndex extends Component {
    constructor(props) {
        super(props)
        this.state = {
            data: [],
            defaultActiveKey: undefined,
        }
    }


    render() {
        return (
            <div className={css.main_right_content} style={{height: getSize().windowH - 123}}>
                <Tabs defaultActiveKey={this.state.defaultActiveKey}>
                    <TabPane tab="自助报到办理汇总" key="1"><ZzbdblcxTab/></TabPane>
                    <TabPane tab="自助报到办理详情" key="2"><ZzbdxqTab/></TabPane>
                </Tabs>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./components/tjcx/zzbdblcx/index.js